/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAiProvidersRouteImport } from './routes/admin/ai-providers'
import { Route as AdminGeneralRouteImport } from './routes/admin/general'
import { Route as AdminHarnessesRouteImport } from './routes/admin/harnesses'
import { Route as AdminLimitsRouteImport } from './routes/admin/limits'
import { Route as AdminLinkedAccountsRouteImport } from './routes/admin/linked-accounts'
import { Route as AdminNotificationsRouteImport } from './routes/admin/notifications'
import { Route as AdminWorkspacesRouteImport } from './routes/admin/workspaces'
import { Route as OidcCallbackRouteImport } from './routes/oidc/callback'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsAccountRouteImport } from './routes/settings/account'
import { Route as SettingsCommitsRouteImport } from './routes/settings/commits'
import { Route as SettingsEditorRouteImport } from './routes/settings/editor'
import { Route as SettingsNotificationsRouteImport } from './routes/settings/notifications'
import { Route as WorkspacesWorkspaceIdRouteRouteImport } from './routes/workspaces/$workspaceId/route'
import { Route as WorkspacesWorkspaceIdIndexRouteImport } from './routes/workspaces/$workspaceId/index'
import { Route as WorkspacesWorkspaceIdAiModelsRouteImport } from './routes/workspaces/$workspaceId/ai-models'
import { Route as WorkspacesWorkspaceIdAiUsageRouteRouteImport } from './routes/workspaces/$workspaceId/ai-usage/route'
import { Route as WorkspacesWorkspaceIdAuditRouteImport } from './routes/workspaces/$workspaceId/audit'
import { Route as WorkspacesWorkspaceIdConnectionsRouteImport } from './routes/workspaces/$workspaceId/connections'
import { Route as WorkspacesWorkspaceIdExecutionImagesRouteImport } from './routes/workspaces/$workspaceId/execution-images'
import { Route as WorkspacesWorkspaceIdIntegrationsRouteRouteImport } from './routes/workspaces/$workspaceId/integrations/route'
import { Route as WorkspacesWorkspaceIdLibraryRouteImport } from './routes/workspaces/$workspaceId/library'
import { Route as WorkspacesWorkspaceIdSecretsRouteImport } from './routes/workspaces/$workspaceId/secrets'
import { Route as WorkspacesWorkspaceIdSettingsRouteRouteImport } from './routes/workspaces/$workspaceId/settings/route'
import { Route as WorkspacesWorkspaceIdTasksRouteImport } from './routes/workspaces/$workspaceId/tasks'
import { Route as WorkspacesWorkspaceIdTriggersRouteImport } from './routes/workspaces/$workspaceId/triggers'
import { Route as WorkspacesWorkspaceIdUsageRouteImport } from './routes/workspaces/$workspaceId/usage'
import { Route as WorkspacesWorkspaceIdAiUsageIndexRouteImport } from './routes/workspaces/$workspaceId/ai-usage/index'
import { Route as WorkspacesWorkspaceIdAiUsageModelsRouteImport } from './routes/workspaces/$workspaceId/ai-usage/models'
import { Route as WorkspacesWorkspaceIdAiUsageSpendRouteImport } from './routes/workspaces/$workspaceId/ai-usage/spend'
import { Route as WorkspacesWorkspaceIdBoardsIndexRouteImport } from './routes/workspaces/$workspaceId/boards/index'
import { Route as WorkspacesWorkspaceIdBoardsWorkflowKeyRouteImport } from './routes/workspaces/$workspaceId/boards/$workflowKey'
import { Route as WorkspacesWorkspaceIdFilesIndexRouteImport } from './routes/workspaces/$workspaceId/files/index'
import { Route as WorkspacesWorkspaceIdFilesAgentsSkillsRouteImport } from './routes/workspaces/$workspaceId/files/agents-skills'
import { Route as WorkspacesWorkspaceIdIntegrationsIndexRouteImport } from './routes/workspaces/$workspaceId/integrations/index'
import { Route as WorkspacesWorkspaceIdIntegrationsConnectionsRouteImport } from './routes/workspaces/$workspaceId/integrations/connections'
import { Route as WorkspacesWorkspaceIdIntegrationsSecretsRouteImport } from './routes/workspaces/$workspaceId/integrations/secrets'
import { Route as WorkspacesWorkspaceIdIntegrationsTriggersRouteImport } from './routes/workspaces/$workspaceId/integrations/triggers'
import { Route as WorkspacesWorkspaceIdSettingsIndexRouteImport } from './routes/workspaces/$workspaceId/settings/index'
import { Route as WorkspacesWorkspaceIdSettingsActivityRouteImport } from './routes/workspaces/$workspaceId/settings/activity'
import { Route as WorkspacesWorkspaceIdSettingsGeneralRouteImport } from './routes/workspaces/$workspaceId/settings/general'
import { Route as WorkspacesWorkspaceIdSettingsImagesRouteImport } from './routes/workspaces/$workspaceId/settings/images'
import { Route as WorkspacesWorkspaceIdSettingsLabelsRouteImport } from './routes/workspaces/$workspaceId/settings/labels'
import { Route as WorkspacesWorkspaceIdSettingsPeopleRouteImport } from './routes/workspaces/$workspaceId/settings/people'
import { Route as WorkspacesWorkspaceIdWorkflowsIndexRouteImport } from './routes/workspaces/$workspaceId/workflows/index'
import { Route as WorkspacesWorkspaceIdWorkflowsWorkflowKeyIndexRouteImport } from './routes/workspaces/$workspaceId/workflows/$workflowKey/index'
import { Route as WorkspacesWorkspaceIdWorkflowsWorkflowKeyBoardRouteImport } from './routes/workspaces/$workspaceId/workflows/$workflowKey/board'
import { Route as WorkspacesWorkspaceIdWorkflowsWorkflowKeyBuilderRouteImport } from './routes/workspaces/$workspaceId/workflows/$workflowKey/builder'
import { Route as WorkspacesWorkspaceIdWorkflowsWorkflowKeyTasksTaskIdRunRouteImport } from './routes/workspaces/$workspaceId/workflows/$workflowKey/tasks/$taskId/run'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAiProvidersRoute = AdminAiProvidersRouteImport.update({
  id: '/ai-providers',
  path: '/ai-providers',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminGeneralRoute = AdminGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminHarnessesRoute = AdminHarnessesRouteImport.update({
  id: '/harnesses',
  path: '/harnesses',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminLimitsRoute = AdminLimitsRouteImport.update({
  id: '/limits',
  path: '/limits',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminLinkedAccountsRoute = AdminLinkedAccountsRouteImport.update({
  id: '/linked-accounts',
  path: '/linked-accounts',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminNotificationsRoute = AdminNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminWorkspacesRoute = AdminWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AdminRouteRoute,
} as any)
const OidcCallbackRoute = OidcCallbackRouteImport.update({
  id: '/oidc/callback',
  path: '/oidc/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsCommitsRoute = SettingsCommitsRouteImport.update({
  id: '/commits',
  path: '/commits',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsEditorRoute = SettingsEditorRouteImport.update({
  id: '/editor',
  path: '/editor',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const WorkspacesWorkspaceIdRouteRoute =
  WorkspacesWorkspaceIdRouteRouteImport.update({
    id: '/workspaces/$workspaceId',
    path: '/workspaces/$workspaceId',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspacesWorkspaceIdIndexRoute =
  WorkspacesWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdAiModelsRoute =
  WorkspacesWorkspaceIdAiModelsRouteImport.update({
    id: '/ai-models',
    path: '/ai-models',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdAiUsageRouteRoute =
  WorkspacesWorkspaceIdAiUsageRouteRouteImport.update({
    id: '/ai-usage',
    path: '/ai-usage',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdAuditRoute =
  WorkspacesWorkspaceIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdConnectionsRoute =
  WorkspacesWorkspaceIdConnectionsRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdExecutionImagesRoute =
  WorkspacesWorkspaceIdExecutionImagesRouteImport.update({
    id: '/execution-images',
    path: '/execution-images',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdIntegrationsRouteRoute =
  WorkspacesWorkspaceIdIntegrationsRouteRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdLibraryRoute =
  WorkspacesWorkspaceIdLibraryRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdSecretsRoute =
  WorkspacesWorkspaceIdSecretsRouteImport.update({
    id: '/secrets',
    path: '/secrets',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdSettingsRouteRoute =
  WorkspacesWorkspaceIdSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdTasksRoute =
  WorkspacesWorkspaceIdTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdTriggersRoute =
  WorkspacesWorkspaceIdTriggersRouteImport.update({
    id: '/triggers',
    path: '/triggers',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdUsageRoute =
  WorkspacesWorkspaceIdUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdAiUsageIndexRoute =
  WorkspacesWorkspaceIdAiUsageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdAiUsageRouteRoute,
  } as any)
const WorkspacesWorkspaceIdAiUsageModelsRoute =
  WorkspacesWorkspaceIdAiUsageModelsRouteImport.update({
    id: '/models',
    path: '/models',
    getParentRoute: () => WorkspacesWorkspaceIdAiUsageRouteRoute,
  } as any)
const WorkspacesWorkspaceIdAiUsageSpendRoute =
  WorkspacesWorkspaceIdAiUsageSpendRouteImport.update({
    id: '/spend',
    path: '/spend',
    getParentRoute: () => WorkspacesWorkspaceIdAiUsageRouteRoute,
  } as any)
const WorkspacesWorkspaceIdBoardsIndexRoute =
  WorkspacesWorkspaceIdBoardsIndexRouteImport.update({
    id: '/boards/',
    path: '/boards/',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdBoardsWorkflowKeyRoute =
  WorkspacesWorkspaceIdBoardsWorkflowKeyRouteImport.update({
    id: '/boards/$workflowKey',
    path: '/boards/$workflowKey',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdFilesIndexRoute =
  WorkspacesWorkspaceIdFilesIndexRouteImport.update({
    id: '/files/',
    path: '/files/',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdFilesAgentsSkillsRoute =
  WorkspacesWorkspaceIdFilesAgentsSkillsRouteImport.update({
    id: '/files/agents-skills',
    path: '/files/agents-skills',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdIntegrationsIndexRoute =
  WorkspacesWorkspaceIdIntegrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsRouteRoute,
  } as any)
const WorkspacesWorkspaceIdIntegrationsConnectionsRoute =
  WorkspacesWorkspaceIdIntegrationsConnectionsRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsRouteRoute,
  } as any)
const WorkspacesWorkspaceIdIntegrationsSecretsRoute =
  WorkspacesWorkspaceIdIntegrationsSecretsRouteImport.update({
    id: '/secrets',
    path: '/secrets',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsRouteRoute,
  } as any)
const WorkspacesWorkspaceIdIntegrationsTriggersRoute =
  WorkspacesWorkspaceIdIntegrationsTriggersRouteImport.update({
    id: '/triggers',
    path: '/triggers',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsRouteRoute,
  } as any)
const WorkspacesWorkspaceIdSettingsIndexRoute =
  WorkspacesWorkspaceIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const WorkspacesWorkspaceIdSettingsActivityRoute =
  WorkspacesWorkspaceIdSettingsActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const WorkspacesWorkspaceIdSettingsGeneralRoute =
  WorkspacesWorkspaceIdSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const WorkspacesWorkspaceIdSettingsImagesRoute =
  WorkspacesWorkspaceIdSettingsImagesRouteImport.update({
    id: '/images',
    path: '/images',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const WorkspacesWorkspaceIdSettingsLabelsRoute =
  WorkspacesWorkspaceIdSettingsLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const WorkspacesWorkspaceIdSettingsPeopleRoute =
  WorkspacesWorkspaceIdSettingsPeopleRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const WorkspacesWorkspaceIdWorkflowsIndexRoute =
  WorkspacesWorkspaceIdWorkflowsIndexRouteImport.update({
    id: '/workflows/',
    path: '/workflows/',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdWorkflowsWorkflowKeyIndexRoute =
  WorkspacesWorkspaceIdWorkflowsWorkflowKeyIndexRouteImport.update({
    id: '/workflows/$workflowKey/',
    path: '/workflows/$workflowKey/',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdWorkflowsWorkflowKeyBoardRoute =
  WorkspacesWorkspaceIdWorkflowsWorkflowKeyBoardRouteImport.update({
    id: '/workflows/$workflowKey/board',
    path: '/workflows/$workflowKey/board',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdWorkflowsWorkflowKeyBuilderRoute =
  WorkspacesWorkspaceIdWorkflowsWorkflowKeyBuilderRouteImport.update({
    id: '/workflows/$workflowKey/builder',
    path: '/workflows/$workflowKey/builder',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdWorkflowsWorkflowKeyTasksTaskIdRunRoute =
  WorkspacesWorkspaceIdWorkflowsWorkflowKeyTasksTaskIdRunRouteImport.update({
    id: '/workflows/$workflowKey/tasks/$taskId/run',
    path: '/workflows/$workflowKey/tasks/$taskId/run',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/notifications': typeof NotificationsRoute
  '/workspaces/$workspaceId': typeof WorkspacesWorkspaceIdRouteRouteWithChildren
  '/admin/ai-providers': typeof AdminAiProvidersRoute
  '/admin/general': typeof AdminGeneralRoute
  '/admin/harnesses': typeof AdminHarnessesRoute
  '/admin/limits': typeof AdminLimitsRoute
  '/admin/linked-accounts': typeof AdminLinkedAccountsRoute
  '/admin/notifications': typeof AdminNotificationsRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/oidc/callback': typeof OidcCallbackRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/commits': typeof SettingsCommitsRoute
  '/settings/editor': typeof SettingsEditorRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/admin/': typeof AdminIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/workspaces/$workspaceId/ai-usage': typeof WorkspacesWorkspaceIdAiUsageRouteRouteWithChildren
  '/workspaces/$workspaceId/integrations': typeof WorkspacesWorkspaceIdIntegrationsRouteRouteWithChildren
  '/workspaces/$workspaceId/settings': typeof WorkspacesWorkspaceIdSettingsRouteRouteWithChildren
  '/workspaces/$workspaceId/ai-models': typeof WorkspacesWorkspaceIdAiModelsRoute
  '/workspaces/$workspaceId/audit': typeof WorkspacesWorkspaceIdAuditRoute
  '/workspaces/$workspaceId/connections': typeof WorkspacesWorkspaceIdConnectionsRoute
  '/workspaces/$workspaceId/execution-images': typeof WorkspacesWorkspaceIdExecutionImagesRoute
  '/workspaces/$workspaceId/library': typeof WorkspacesWorkspaceIdLibraryRoute
  '/workspaces/$workspaceId/secrets': typeof WorkspacesWorkspaceIdSecretsRoute
  '/workspaces/$workspaceId/tasks': typeof WorkspacesWorkspaceIdTasksRoute
  '/workspaces/$workspaceId/triggers': typeof WorkspacesWorkspaceIdTriggersRoute
  '/workspaces/$workspaceId/usage': typeof WorkspacesWorkspaceIdUsageRoute
  '/workspaces/$workspaceId/': typeof WorkspacesWorkspaceIdIndexRoute
  '/workspaces/$workspaceId/ai-usage/models': typeof WorkspacesWorkspaceIdAiUsageModelsRoute
  '/workspaces/$workspaceId/ai-usage/spend': typeof WorkspacesWorkspaceIdAiUsageSpendRoute
  '/workspaces/$workspaceId/boards/$workflowKey': typeof WorkspacesWorkspaceIdBoardsWorkflowKeyRoute
  '/workspaces/$workspaceId/files/agents-skills': typeof WorkspacesWorkspaceIdFilesAgentsSkillsRoute
  '/workspaces/$workspaceId/integrations/connections': typeof WorkspacesWorkspaceIdIntegrationsConnectionsRoute
  '/workspaces/$workspaceId/integrations/secrets': typeof WorkspacesWorkspaceIdIntegrationsSecretsRoute
  '/workspaces/$workspaceId/integrations/triggers': typeof WorkspacesWorkspaceIdIntegrationsTriggersRoute
  '/workspaces/$workspaceId/settings/activity': typeof WorkspacesWorkspaceIdSettingsActivityRoute
  '/workspaces/$workspaceId/settings/general': typeof WorkspacesWorkspaceIdSettingsGeneralRoute
  '/workspaces/$workspaceId/settings/images': typeof WorkspacesWorkspaceIdSettingsImagesRoute
  '/workspaces/$workspaceId/settings/labels': typeof WorkspacesWorkspaceIdSettingsLabelsRoute
  '/workspaces/$workspaceId/settings/people': typeof WorkspacesWorkspaceIdSettingsPeopleRoute
  '/workspaces/$workspaceId/ai-usage/': typeof WorkspacesWorkspaceIdAiUsageIndexRoute
  '/workspaces/$workspaceId/boards/': typeof WorkspacesWorkspaceIdBoardsIndexRoute
  '/workspaces/$workspaceId/files/': typeof WorkspacesWorkspaceIdFilesIndexRoute
  '/workspaces/$workspaceId/integrations/': typeof WorkspacesWorkspaceIdIntegrationsIndexRoute
  '/workspaces/$workspaceId/settings/': typeof WorkspacesWorkspaceIdSettingsIndexRoute
  '/workspaces/$workspaceId/workflows/': typeof WorkspacesWorkspaceIdWorkflowsIndexRoute
  '/workspaces/$workspaceId/workflows/$workflowKey/board': typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyBoardRoute
  '/workspaces/$workspaceId/workflows/$workflowKey/builder': typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyBuilderRoute
  '/workspaces/$workspaceId/workflows/$workflowKey/': typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyIndexRoute
  '/workspaces/$workspaceId/workflows/$workflowKey/tasks/$taskId/run': typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyTasksTaskIdRunRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/notifications': typeof NotificationsRoute
  '/admin/ai-providers': typeof AdminAiProvidersRoute
  '/admin/general': typeof AdminGeneralRoute
  '/admin/harnesses': typeof AdminHarnessesRoute
  '/admin/limits': typeof AdminLimitsRoute
  '/admin/linked-accounts': typeof AdminLinkedAccountsRoute
  '/admin/notifications': typeof AdminNotificationsRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/oidc/callback': typeof OidcCallbackRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/commits': typeof SettingsCommitsRoute
  '/settings/editor': typeof SettingsEditorRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/admin': typeof AdminIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/workspaces/$workspaceId/ai-models': typeof WorkspacesWorkspaceIdAiModelsRoute
  '/workspaces/$workspaceId/audit': typeof WorkspacesWorkspaceIdAuditRoute
  '/workspaces/$workspaceId/connections': typeof WorkspacesWorkspaceIdConnectionsRoute
  '/workspaces/$workspaceId/execution-images': typeof WorkspacesWorkspaceIdExecutionImagesRoute
  '/workspaces/$workspaceId/library': typeof WorkspacesWorkspaceIdLibraryRoute
  '/workspaces/$workspaceId/secrets': typeof WorkspacesWorkspaceIdSecretsRoute
  '/workspaces/$workspaceId/tasks': typeof WorkspacesWorkspaceIdTasksRoute
  '/workspaces/$workspaceId/triggers': typeof WorkspacesWorkspaceIdTriggersRoute
  '/workspaces/$workspaceId/usage': typeof WorkspacesWorkspaceIdUsageRoute
  '/workspaces/$workspaceId': typeof WorkspacesWorkspaceIdIndexRoute
  '/workspaces/$workspaceId/ai-usage/models': typeof WorkspacesWorkspaceIdAiUsageModelsRoute
  '/workspaces/$workspaceId/ai-usage/spend': typeof WorkspacesWorkspaceIdAiUsageSpendRoute
  '/workspaces/$workspaceId/boards/$workflowKey': typeof WorkspacesWorkspaceIdBoardsWorkflowKeyRoute
  '/workspaces/$workspaceId/files/agents-skills': typeof WorkspacesWorkspaceIdFilesAgentsSkillsRoute
  '/workspaces/$workspaceId/integrations/connections': typeof WorkspacesWorkspaceIdIntegrationsConnectionsRoute
  '/workspaces/$workspaceId/integrations/secrets': typeof WorkspacesWorkspaceIdIntegrationsSecretsRoute
  '/workspaces/$workspaceId/integrations/triggers': typeof WorkspacesWorkspaceIdIntegrationsTriggersRoute
  '/workspaces/$workspaceId/settings/activity': typeof WorkspacesWorkspaceIdSettingsActivityRoute
  '/workspaces/$workspaceId/settings/general': typeof WorkspacesWorkspaceIdSettingsGeneralRoute
  '/workspaces/$workspaceId/settings/images': typeof WorkspacesWorkspaceIdSettingsImagesRoute
  '/workspaces/$workspaceId/settings/labels': typeof WorkspacesWorkspaceIdSettingsLabelsRoute
  '/workspaces/$workspaceId/settings/people': typeof WorkspacesWorkspaceIdSettingsPeopleRoute
  '/workspaces/$workspaceId/ai-usage': typeof WorkspacesWorkspaceIdAiUsageIndexRoute
  '/workspaces/$workspaceId/boards': typeof WorkspacesWorkspaceIdBoardsIndexRoute
  '/workspaces/$workspaceId/files': typeof WorkspacesWorkspaceIdFilesIndexRoute
  '/workspaces/$workspaceId/integrations': typeof WorkspacesWorkspaceIdIntegrationsIndexRoute
  '/workspaces/$workspaceId/settings': typeof WorkspacesWorkspaceIdSettingsIndexRoute
  '/workspaces/$workspaceId/workflows': typeof WorkspacesWorkspaceIdWorkflowsIndexRoute
  '/workspaces/$workspaceId/workflows/$workflowKey/board': typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyBoardRoute
  '/workspaces/$workspaceId/workflows/$workflowKey/builder': typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyBuilderRoute
  '/workspaces/$workspaceId/workflows/$workflowKey': typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyIndexRoute
  '/workspaces/$workspaceId/workflows/$workflowKey/tasks/$taskId/run': typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyTasksTaskIdRunRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/notifications': typeof NotificationsRoute
  '/workspaces/$workspaceId': typeof WorkspacesWorkspaceIdRouteRouteWithChildren
  '/admin/ai-providers': typeof AdminAiProvidersRoute
  '/admin/general': typeof AdminGeneralRoute
  '/admin/harnesses': typeof AdminHarnessesRoute
  '/admin/limits': typeof AdminLimitsRoute
  '/admin/linked-accounts': typeof AdminLinkedAccountsRoute
  '/admin/notifications': typeof AdminNotificationsRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/oidc/callback': typeof OidcCallbackRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/commits': typeof SettingsCommitsRoute
  '/settings/editor': typeof SettingsEditorRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/admin/': typeof AdminIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/workspaces/$workspaceId/ai-usage': typeof WorkspacesWorkspaceIdAiUsageRouteRouteWithChildren
  '/workspaces/$workspaceId/integrations': typeof WorkspacesWorkspaceIdIntegrationsRouteRouteWithChildren
  '/workspaces/$workspaceId/settings': typeof WorkspacesWorkspaceIdSettingsRouteRouteWithChildren
  '/workspaces/$workspaceId/ai-models': typeof WorkspacesWorkspaceIdAiModelsRoute
  '/workspaces/$workspaceId/audit': typeof WorkspacesWorkspaceIdAuditRoute
  '/workspaces/$workspaceId/connections': typeof WorkspacesWorkspaceIdConnectionsRoute
  '/workspaces/$workspaceId/execution-images': typeof WorkspacesWorkspaceIdExecutionImagesRoute
  '/workspaces/$workspaceId/library': typeof WorkspacesWorkspaceIdLibraryRoute
  '/workspaces/$workspaceId/secrets': typeof WorkspacesWorkspaceIdSecretsRoute
  '/workspaces/$workspaceId/tasks': typeof WorkspacesWorkspaceIdTasksRoute
  '/workspaces/$workspaceId/triggers': typeof WorkspacesWorkspaceIdTriggersRoute
  '/workspaces/$workspaceId/usage': typeof WorkspacesWorkspaceIdUsageRoute
  '/workspaces/$workspaceId/': typeof WorkspacesWorkspaceIdIndexRoute
  '/workspaces/$workspaceId/ai-usage/models': typeof WorkspacesWorkspaceIdAiUsageModelsRoute
  '/workspaces/$workspaceId/ai-usage/spend': typeof WorkspacesWorkspaceIdAiUsageSpendRoute
  '/workspaces/$workspaceId/boards/$workflowKey': typeof WorkspacesWorkspaceIdBoardsWorkflowKeyRoute
  '/workspaces/$workspaceId/files/agents-skills': typeof WorkspacesWorkspaceIdFilesAgentsSkillsRoute
  '/workspaces/$workspaceId/integrations/connections': typeof WorkspacesWorkspaceIdIntegrationsConnectionsRoute
  '/workspaces/$workspaceId/integrations/secrets': typeof WorkspacesWorkspaceIdIntegrationsSecretsRoute
  '/workspaces/$workspaceId/integrations/triggers': typeof WorkspacesWorkspaceIdIntegrationsTriggersRoute
  '/workspaces/$workspaceId/settings/activity': typeof WorkspacesWorkspaceIdSettingsActivityRoute
  '/workspaces/$workspaceId/settings/general': typeof WorkspacesWorkspaceIdSettingsGeneralRoute
  '/workspaces/$workspaceId/settings/images': typeof WorkspacesWorkspaceIdSettingsImagesRoute
  '/workspaces/$workspaceId/settings/labels': typeof WorkspacesWorkspaceIdSettingsLabelsRoute
  '/workspaces/$workspaceId/settings/people': typeof WorkspacesWorkspaceIdSettingsPeopleRoute
  '/workspaces/$workspaceId/ai-usage/': typeof WorkspacesWorkspaceIdAiUsageIndexRoute
  '/workspaces/$workspaceId/boards/': typeof WorkspacesWorkspaceIdBoardsIndexRoute
  '/workspaces/$workspaceId/files/': typeof WorkspacesWorkspaceIdFilesIndexRoute
  '/workspaces/$workspaceId/integrations/': typeof WorkspacesWorkspaceIdIntegrationsIndexRoute
  '/workspaces/$workspaceId/settings/': typeof WorkspacesWorkspaceIdSettingsIndexRoute
  '/workspaces/$workspaceId/workflows/': typeof WorkspacesWorkspaceIdWorkflowsIndexRoute
  '/workspaces/$workspaceId/workflows/$workflowKey/board': typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyBoardRoute
  '/workspaces/$workspaceId/workflows/$workflowKey/builder': typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyBuilderRoute
  '/workspaces/$workspaceId/workflows/$workflowKey/': typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyIndexRoute
  '/workspaces/$workspaceId/workflows/$workflowKey/tasks/$taskId/run': typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyTasksTaskIdRunRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/settings'
    | '/notifications'
    | '/workspaces/$workspaceId'
    | '/admin/ai-providers'
    | '/admin/general'
    | '/admin/harnesses'
    | '/admin/limits'
    | '/admin/linked-accounts'
    | '/admin/notifications'
    | '/admin/workspaces'
    | '/oidc/callback'
    | '/settings/account'
    | '/settings/commits'
    | '/settings/editor'
    | '/settings/notifications'
    | '/admin/'
    | '/settings/'
    | '/workspaces/$workspaceId/ai-usage'
    | '/workspaces/$workspaceId/integrations'
    | '/workspaces/$workspaceId/settings'
    | '/workspaces/$workspaceId/ai-models'
    | '/workspaces/$workspaceId/audit'
    | '/workspaces/$workspaceId/connections'
    | '/workspaces/$workspaceId/execution-images'
    | '/workspaces/$workspaceId/library'
    | '/workspaces/$workspaceId/secrets'
    | '/workspaces/$workspaceId/tasks'
    | '/workspaces/$workspaceId/triggers'
    | '/workspaces/$workspaceId/usage'
    | '/workspaces/$workspaceId/'
    | '/workspaces/$workspaceId/ai-usage/models'
    | '/workspaces/$workspaceId/ai-usage/spend'
    | '/workspaces/$workspaceId/boards/$workflowKey'
    | '/workspaces/$workspaceId/files/agents-skills'
    | '/workspaces/$workspaceId/integrations/connections'
    | '/workspaces/$workspaceId/integrations/secrets'
    | '/workspaces/$workspaceId/integrations/triggers'
    | '/workspaces/$workspaceId/settings/activity'
    | '/workspaces/$workspaceId/settings/general'
    | '/workspaces/$workspaceId/settings/images'
    | '/workspaces/$workspaceId/settings/labels'
    | '/workspaces/$workspaceId/settings/people'
    | '/workspaces/$workspaceId/ai-usage/'
    | '/workspaces/$workspaceId/boards/'
    | '/workspaces/$workspaceId/files/'
    | '/workspaces/$workspaceId/integrations/'
    | '/workspaces/$workspaceId/settings/'
    | '/workspaces/$workspaceId/workflows/'
    | '/workspaces/$workspaceId/workflows/$workflowKey/board'
    | '/workspaces/$workspaceId/workflows/$workflowKey/builder'
    | '/workspaces/$workspaceId/workflows/$workflowKey/'
    | '/workspaces/$workspaceId/workflows/$workflowKey/tasks/$taskId/run'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/notifications'
    | '/admin/ai-providers'
    | '/admin/general'
    | '/admin/harnesses'
    | '/admin/limits'
    | '/admin/linked-accounts'
    | '/admin/notifications'
    | '/admin/workspaces'
    | '/oidc/callback'
    | '/settings/account'
    | '/settings/commits'
    | '/settings/editor'
    | '/settings/notifications'
    | '/admin'
    | '/settings'
    | '/workspaces/$workspaceId/ai-models'
    | '/workspaces/$workspaceId/audit'
    | '/workspaces/$workspaceId/connections'
    | '/workspaces/$workspaceId/execution-images'
    | '/workspaces/$workspaceId/library'
    | '/workspaces/$workspaceId/secrets'
    | '/workspaces/$workspaceId/tasks'
    | '/workspaces/$workspaceId/triggers'
    | '/workspaces/$workspaceId/usage'
    | '/workspaces/$workspaceId'
    | '/workspaces/$workspaceId/ai-usage/models'
    | '/workspaces/$workspaceId/ai-usage/spend'
    | '/workspaces/$workspaceId/boards/$workflowKey'
    | '/workspaces/$workspaceId/files/agents-skills'
    | '/workspaces/$workspaceId/integrations/connections'
    | '/workspaces/$workspaceId/integrations/secrets'
    | '/workspaces/$workspaceId/integrations/triggers'
    | '/workspaces/$workspaceId/settings/activity'
    | '/workspaces/$workspaceId/settings/general'
    | '/workspaces/$workspaceId/settings/images'
    | '/workspaces/$workspaceId/settings/labels'
    | '/workspaces/$workspaceId/settings/people'
    | '/workspaces/$workspaceId/ai-usage'
    | '/workspaces/$workspaceId/boards'
    | '/workspaces/$workspaceId/files'
    | '/workspaces/$workspaceId/integrations'
    | '/workspaces/$workspaceId/settings'
    | '/workspaces/$workspaceId/workflows'
    | '/workspaces/$workspaceId/workflows/$workflowKey/board'
    | '/workspaces/$workspaceId/workflows/$workflowKey/builder'
    | '/workspaces/$workspaceId/workflows/$workflowKey'
    | '/workspaces/$workspaceId/workflows/$workflowKey/tasks/$taskId/run'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/settings'
    | '/notifications'
    | '/workspaces/$workspaceId'
    | '/admin/ai-providers'
    | '/admin/general'
    | '/admin/harnesses'
    | '/admin/limits'
    | '/admin/linked-accounts'
    | '/admin/notifications'
    | '/admin/workspaces'
    | '/oidc/callback'
    | '/settings/account'
    | '/settings/commits'
    | '/settings/editor'
    | '/settings/notifications'
    | '/admin/'
    | '/settings/'
    | '/workspaces/$workspaceId/ai-usage'
    | '/workspaces/$workspaceId/integrations'
    | '/workspaces/$workspaceId/settings'
    | '/workspaces/$workspaceId/ai-models'
    | '/workspaces/$workspaceId/audit'
    | '/workspaces/$workspaceId/connections'
    | '/workspaces/$workspaceId/execution-images'
    | '/workspaces/$workspaceId/library'
    | '/workspaces/$workspaceId/secrets'
    | '/workspaces/$workspaceId/tasks'
    | '/workspaces/$workspaceId/triggers'
    | '/workspaces/$workspaceId/usage'
    | '/workspaces/$workspaceId/'
    | '/workspaces/$workspaceId/ai-usage/models'
    | '/workspaces/$workspaceId/ai-usage/spend'
    | '/workspaces/$workspaceId/boards/$workflowKey'
    | '/workspaces/$workspaceId/files/agents-skills'
    | '/workspaces/$workspaceId/integrations/connections'
    | '/workspaces/$workspaceId/integrations/secrets'
    | '/workspaces/$workspaceId/integrations/triggers'
    | '/workspaces/$workspaceId/settings/activity'
    | '/workspaces/$workspaceId/settings/general'
    | '/workspaces/$workspaceId/settings/images'
    | '/workspaces/$workspaceId/settings/labels'
    | '/workspaces/$workspaceId/settings/people'
    | '/workspaces/$workspaceId/ai-usage/'
    | '/workspaces/$workspaceId/boards/'
    | '/workspaces/$workspaceId/files/'
    | '/workspaces/$workspaceId/integrations/'
    | '/workspaces/$workspaceId/settings/'
    | '/workspaces/$workspaceId/workflows/'
    | '/workspaces/$workspaceId/workflows/$workflowKey/board'
    | '/workspaces/$workspaceId/workflows/$workflowKey/builder'
    | '/workspaces/$workspaceId/workflows/$workflowKey/'
    | '/workspaces/$workspaceId/workflows/$workflowKey/tasks/$taskId/run'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  NotificationsRoute: typeof NotificationsRoute
  WorkspacesWorkspaceIdRouteRoute: typeof WorkspacesWorkspaceIdRouteRouteWithChildren
  OidcCallbackRoute: typeof OidcCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/ai-providers': {
      id: '/admin/ai-providers'
      path: '/ai-providers'
      fullPath: '/admin/ai-providers'
      preLoaderRoute: typeof AdminAiProvidersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/general': {
      id: '/admin/general'
      path: '/general'
      fullPath: '/admin/general'
      preLoaderRoute: typeof AdminGeneralRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/harnesses': {
      id: '/admin/harnesses'
      path: '/harnesses'
      fullPath: '/admin/harnesses'
      preLoaderRoute: typeof AdminHarnessesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/limits': {
      id: '/admin/limits'
      path: '/limits'
      fullPath: '/admin/limits'
      preLoaderRoute: typeof AdminLimitsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/linked-accounts': {
      id: '/admin/linked-accounts'
      path: '/linked-accounts'
      fullPath: '/admin/linked-accounts'
      preLoaderRoute: typeof AdminLinkedAccountsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/notifications': {
      id: '/admin/notifications'
      path: '/notifications'
      fullPath: '/admin/notifications'
      preLoaderRoute: typeof AdminNotificationsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/workspaces': {
      id: '/admin/workspaces'
      path: '/workspaces'
      fullPath: '/admin/workspaces'
      preLoaderRoute: typeof AdminWorkspacesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/oidc/callback': {
      id: '/oidc/callback'
      path: '/oidc/callback'
      fullPath: '/oidc/callback'
      preLoaderRoute: typeof OidcCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/commits': {
      id: '/settings/commits'
      path: '/commits'
      fullPath: '/settings/commits'
      preLoaderRoute: typeof SettingsCommitsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/editor': {
      id: '/settings/editor'
      path: '/editor'
      fullPath: '/settings/editor'
      preLoaderRoute: typeof SettingsEditorRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/workspaces/$workspaceId': {
      id: '/workspaces/$workspaceId'
      path: '/workspaces/$workspaceId'
      fullPath: '/workspaces/$workspaceId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspaces/$workspaceId/': {
      id: '/workspaces/$workspaceId/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/ai-models': {
      id: '/workspaces/$workspaceId/ai-models'
      path: '/ai-models'
      fullPath: '/workspaces/$workspaceId/ai-models'
      preLoaderRoute: typeof WorkspacesWorkspaceIdAiModelsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/ai-usage': {
      id: '/workspaces/$workspaceId/ai-usage'
      path: '/ai-usage'
      fullPath: '/workspaces/$workspaceId/ai-usage'
      preLoaderRoute: typeof WorkspacesWorkspaceIdAiUsageRouteRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/audit': {
      id: '/workspaces/$workspaceId/audit'
      path: '/audit'
      fullPath: '/workspaces/$workspaceId/audit'
      preLoaderRoute: typeof WorkspacesWorkspaceIdAuditRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/connections': {
      id: '/workspaces/$workspaceId/connections'
      path: '/connections'
      fullPath: '/workspaces/$workspaceId/connections'
      preLoaderRoute: typeof WorkspacesWorkspaceIdConnectionsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/execution-images': {
      id: '/workspaces/$workspaceId/execution-images'
      path: '/execution-images'
      fullPath: '/workspaces/$workspaceId/execution-images'
      preLoaderRoute: typeof WorkspacesWorkspaceIdExecutionImagesRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/integrations': {
      id: '/workspaces/$workspaceId/integrations'
      path: '/integrations'
      fullPath: '/workspaces/$workspaceId/integrations'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsRouteRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/library': {
      id: '/workspaces/$workspaceId/library'
      path: '/library'
      fullPath: '/workspaces/$workspaceId/library'
      preLoaderRoute: typeof WorkspacesWorkspaceIdLibraryRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/secrets': {
      id: '/workspaces/$workspaceId/secrets'
      path: '/secrets'
      fullPath: '/workspaces/$workspaceId/secrets'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSecretsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/settings': {
      id: '/workspaces/$workspaceId/settings'
      path: '/settings'
      fullPath: '/workspaces/$workspaceId/settings'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsRouteRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/tasks': {
      id: '/workspaces/$workspaceId/tasks'
      path: '/tasks'
      fullPath: '/workspaces/$workspaceId/tasks'
      preLoaderRoute: typeof WorkspacesWorkspaceIdTasksRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/triggers': {
      id: '/workspaces/$workspaceId/triggers'
      path: '/triggers'
      fullPath: '/workspaces/$workspaceId/triggers'
      preLoaderRoute: typeof WorkspacesWorkspaceIdTriggersRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/usage': {
      id: '/workspaces/$workspaceId/usage'
      path: '/usage'
      fullPath: '/workspaces/$workspaceId/usage'
      preLoaderRoute: typeof WorkspacesWorkspaceIdUsageRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/ai-usage/': {
      id: '/workspaces/$workspaceId/ai-usage/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/ai-usage/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdAiUsageIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdAiUsageRouteRoute
    }
    '/workspaces/$workspaceId/ai-usage/models': {
      id: '/workspaces/$workspaceId/ai-usage/models'
      path: '/models'
      fullPath: '/workspaces/$workspaceId/ai-usage/models'
      preLoaderRoute: typeof WorkspacesWorkspaceIdAiUsageModelsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdAiUsageRouteRoute
    }
    '/workspaces/$workspaceId/ai-usage/spend': {
      id: '/workspaces/$workspaceId/ai-usage/spend'
      path: '/spend'
      fullPath: '/workspaces/$workspaceId/ai-usage/spend'
      preLoaderRoute: typeof WorkspacesWorkspaceIdAiUsageSpendRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdAiUsageRouteRoute
    }
    '/workspaces/$workspaceId/boards/': {
      id: '/workspaces/$workspaceId/boards/'
      path: '/boards'
      fullPath: '/workspaces/$workspaceId/boards/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBoardsIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/boards/$workflowKey': {
      id: '/workspaces/$workspaceId/boards/$workflowKey'
      path: '/boards/$workflowKey'
      fullPath: '/workspaces/$workspaceId/boards/$workflowKey'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBoardsWorkflowKeyRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/files/': {
      id: '/workspaces/$workspaceId/files/'
      path: '/files'
      fullPath: '/workspaces/$workspaceId/files/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdFilesIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/files/agents-skills': {
      id: '/workspaces/$workspaceId/files/agents-skills'
      path: '/files/agents-skills'
      fullPath: '/workspaces/$workspaceId/files/agents-skills'
      preLoaderRoute: typeof WorkspacesWorkspaceIdFilesAgentsSkillsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/integrations/': {
      id: '/workspaces/$workspaceId/integrations/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/integrations/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsRouteRoute
    }
    '/workspaces/$workspaceId/integrations/connections': {
      id: '/workspaces/$workspaceId/integrations/connections'
      path: '/connections'
      fullPath: '/workspaces/$workspaceId/integrations/connections'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsConnectionsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsRouteRoute
    }
    '/workspaces/$workspaceId/integrations/secrets': {
      id: '/workspaces/$workspaceId/integrations/secrets'
      path: '/secrets'
      fullPath: '/workspaces/$workspaceId/integrations/secrets'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsSecretsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsRouteRoute
    }
    '/workspaces/$workspaceId/integrations/triggers': {
      id: '/workspaces/$workspaceId/integrations/triggers'
      path: '/triggers'
      fullPath: '/workspaces/$workspaceId/integrations/triggers'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsTriggersRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsRouteRoute
    }
    '/workspaces/$workspaceId/settings/': {
      id: '/workspaces/$workspaceId/settings/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/settings/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/workspaces/$workspaceId/settings/activity': {
      id: '/workspaces/$workspaceId/settings/activity'
      path: '/activity'
      fullPath: '/workspaces/$workspaceId/settings/activity'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsActivityRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/workspaces/$workspaceId/settings/general': {
      id: '/workspaces/$workspaceId/settings/general'
      path: '/general'
      fullPath: '/workspaces/$workspaceId/settings/general'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsGeneralRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/workspaces/$workspaceId/settings/images': {
      id: '/workspaces/$workspaceId/settings/images'
      path: '/images'
      fullPath: '/workspaces/$workspaceId/settings/images'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsImagesRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/workspaces/$workspaceId/settings/labels': {
      id: '/workspaces/$workspaceId/settings/labels'
      path: '/labels'
      fullPath: '/workspaces/$workspaceId/settings/labels'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsLabelsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/workspaces/$workspaceId/settings/people': {
      id: '/workspaces/$workspaceId/settings/people'
      path: '/people'
      fullPath: '/workspaces/$workspaceId/settings/people'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsPeopleRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/workspaces/$workspaceId/workflows/': {
      id: '/workspaces/$workspaceId/workflows/'
      path: '/workflows'
      fullPath: '/workspaces/$workspaceId/workflows/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdWorkflowsIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/workflows/$workflowKey/': {
      id: '/workspaces/$workspaceId/workflows/$workflowKey/'
      path: '/workflows/$workflowKey'
      fullPath: '/workspaces/$workspaceId/workflows/$workflowKey/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/workflows/$workflowKey/board': {
      id: '/workspaces/$workspaceId/workflows/$workflowKey/board'
      path: '/workflows/$workflowKey/board'
      fullPath: '/workspaces/$workspaceId/workflows/$workflowKey/board'
      preLoaderRoute: typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyBoardRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/workflows/$workflowKey/builder': {
      id: '/workspaces/$workspaceId/workflows/$workflowKey/builder'
      path: '/workflows/$workflowKey/builder'
      fullPath: '/workspaces/$workspaceId/workflows/$workflowKey/builder'
      preLoaderRoute: typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyBuilderRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/workflows/$workflowKey/tasks/$taskId/run': {
      id: '/workspaces/$workspaceId/workflows/$workflowKey/tasks/$taskId/run'
      path: '/workflows/$workflowKey/tasks/$taskId/run'
      fullPath: '/workspaces/$workspaceId/workflows/$workflowKey/tasks/$taskId/run'
      preLoaderRoute: typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyTasksTaskIdRunRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminAiProvidersRoute: typeof AdminAiProvidersRoute
  AdminGeneralRoute: typeof AdminGeneralRoute
  AdminHarnessesRoute: typeof AdminHarnessesRoute
  AdminLimitsRoute: typeof AdminLimitsRoute
  AdminLinkedAccountsRoute: typeof AdminLinkedAccountsRoute
  AdminNotificationsRoute: typeof AdminNotificationsRoute
  AdminWorkspacesRoute: typeof AdminWorkspacesRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAiProvidersRoute: AdminAiProvidersRoute,
  AdminGeneralRoute: AdminGeneralRoute,
  AdminHarnessesRoute: AdminHarnessesRoute,
  AdminLimitsRoute: AdminLimitsRoute,
  AdminLinkedAccountsRoute: AdminLinkedAccountsRoute,
  AdminNotificationsRoute: AdminNotificationsRoute,
  AdminWorkspacesRoute: AdminWorkspacesRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface SettingsRouteRouteChildren {
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsCommitsRoute: typeof SettingsCommitsRoute
  SettingsEditorRoute: typeof SettingsEditorRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsCommitsRoute: SettingsCommitsRoute,
  SettingsEditorRoute: SettingsEditorRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

interface WorkspacesWorkspaceIdAiUsageRouteRouteChildren {
  WorkspacesWorkspaceIdAiUsageModelsRoute: typeof WorkspacesWorkspaceIdAiUsageModelsRoute
  WorkspacesWorkspaceIdAiUsageSpendRoute: typeof WorkspacesWorkspaceIdAiUsageSpendRoute
  WorkspacesWorkspaceIdAiUsageIndexRoute: typeof WorkspacesWorkspaceIdAiUsageIndexRoute
}

const WorkspacesWorkspaceIdAiUsageRouteRouteChildren: WorkspacesWorkspaceIdAiUsageRouteRouteChildren =
  {
    WorkspacesWorkspaceIdAiUsageModelsRoute:
      WorkspacesWorkspaceIdAiUsageModelsRoute,
    WorkspacesWorkspaceIdAiUsageSpendRoute:
      WorkspacesWorkspaceIdAiUsageSpendRoute,
    WorkspacesWorkspaceIdAiUsageIndexRoute:
      WorkspacesWorkspaceIdAiUsageIndexRoute,
  }

const WorkspacesWorkspaceIdAiUsageRouteRouteWithChildren =
  WorkspacesWorkspaceIdAiUsageRouteRoute._addFileChildren(
    WorkspacesWorkspaceIdAiUsageRouteRouteChildren,
  )

interface WorkspacesWorkspaceIdIntegrationsRouteRouteChildren {
  WorkspacesWorkspaceIdIntegrationsConnectionsRoute: typeof WorkspacesWorkspaceIdIntegrationsConnectionsRoute
  WorkspacesWorkspaceIdIntegrationsSecretsRoute: typeof WorkspacesWorkspaceIdIntegrationsSecretsRoute
  WorkspacesWorkspaceIdIntegrationsTriggersRoute: typeof WorkspacesWorkspaceIdIntegrationsTriggersRoute
  WorkspacesWorkspaceIdIntegrationsIndexRoute: typeof WorkspacesWorkspaceIdIntegrationsIndexRoute
}

const WorkspacesWorkspaceIdIntegrationsRouteRouteChildren: WorkspacesWorkspaceIdIntegrationsRouteRouteChildren =
  {
    WorkspacesWorkspaceIdIntegrationsConnectionsRoute:
      WorkspacesWorkspaceIdIntegrationsConnectionsRoute,
    WorkspacesWorkspaceIdIntegrationsSecretsRoute:
      WorkspacesWorkspaceIdIntegrationsSecretsRoute,
    WorkspacesWorkspaceIdIntegrationsTriggersRoute:
      WorkspacesWorkspaceIdIntegrationsTriggersRoute,
    WorkspacesWorkspaceIdIntegrationsIndexRoute:
      WorkspacesWorkspaceIdIntegrationsIndexRoute,
  }

const WorkspacesWorkspaceIdIntegrationsRouteRouteWithChildren =
  WorkspacesWorkspaceIdIntegrationsRouteRoute._addFileChildren(
    WorkspacesWorkspaceIdIntegrationsRouteRouteChildren,
  )

interface WorkspacesWorkspaceIdSettingsRouteRouteChildren {
  WorkspacesWorkspaceIdSettingsActivityRoute: typeof WorkspacesWorkspaceIdSettingsActivityRoute
  WorkspacesWorkspaceIdSettingsGeneralRoute: typeof WorkspacesWorkspaceIdSettingsGeneralRoute
  WorkspacesWorkspaceIdSettingsImagesRoute: typeof WorkspacesWorkspaceIdSettingsImagesRoute
  WorkspacesWorkspaceIdSettingsLabelsRoute: typeof WorkspacesWorkspaceIdSettingsLabelsRoute
  WorkspacesWorkspaceIdSettingsPeopleRoute: typeof WorkspacesWorkspaceIdSettingsPeopleRoute
  WorkspacesWorkspaceIdSettingsIndexRoute: typeof WorkspacesWorkspaceIdSettingsIndexRoute
}

const WorkspacesWorkspaceIdSettingsRouteRouteChildren: WorkspacesWorkspaceIdSettingsRouteRouteChildren =
  {
    WorkspacesWorkspaceIdSettingsActivityRoute:
      WorkspacesWorkspaceIdSettingsActivityRoute,
    WorkspacesWorkspaceIdSettingsGeneralRoute:
      WorkspacesWorkspaceIdSettingsGeneralRoute,
    WorkspacesWorkspaceIdSettingsImagesRoute:
      WorkspacesWorkspaceIdSettingsImagesRoute,
    WorkspacesWorkspaceIdSettingsLabelsRoute:
      WorkspacesWorkspaceIdSettingsLabelsRoute,
    WorkspacesWorkspaceIdSettingsPeopleRoute:
      WorkspacesWorkspaceIdSettingsPeopleRoute,
    WorkspacesWorkspaceIdSettingsIndexRoute:
      WorkspacesWorkspaceIdSettingsIndexRoute,
  }

const WorkspacesWorkspaceIdSettingsRouteRouteWithChildren =
  WorkspacesWorkspaceIdSettingsRouteRoute._addFileChildren(
    WorkspacesWorkspaceIdSettingsRouteRouteChildren,
  )

interface WorkspacesWorkspaceIdRouteRouteChildren {
  WorkspacesWorkspaceIdAiUsageRouteRoute: typeof WorkspacesWorkspaceIdAiUsageRouteRouteWithChildren
  WorkspacesWorkspaceIdIntegrationsRouteRoute: typeof WorkspacesWorkspaceIdIntegrationsRouteRouteWithChildren
  WorkspacesWorkspaceIdSettingsRouteRoute: typeof WorkspacesWorkspaceIdSettingsRouteRouteWithChildren
  WorkspacesWorkspaceIdAiModelsRoute: typeof WorkspacesWorkspaceIdAiModelsRoute
  WorkspacesWorkspaceIdAuditRoute: typeof WorkspacesWorkspaceIdAuditRoute
  WorkspacesWorkspaceIdConnectionsRoute: typeof WorkspacesWorkspaceIdConnectionsRoute
  WorkspacesWorkspaceIdExecutionImagesRoute: typeof WorkspacesWorkspaceIdExecutionImagesRoute
  WorkspacesWorkspaceIdLibraryRoute: typeof WorkspacesWorkspaceIdLibraryRoute
  WorkspacesWorkspaceIdSecretsRoute: typeof WorkspacesWorkspaceIdSecretsRoute
  WorkspacesWorkspaceIdTasksRoute: typeof WorkspacesWorkspaceIdTasksRoute
  WorkspacesWorkspaceIdTriggersRoute: typeof WorkspacesWorkspaceIdTriggersRoute
  WorkspacesWorkspaceIdUsageRoute: typeof WorkspacesWorkspaceIdUsageRoute
  WorkspacesWorkspaceIdIndexRoute: typeof WorkspacesWorkspaceIdIndexRoute
  WorkspacesWorkspaceIdBoardsWorkflowKeyRoute: typeof WorkspacesWorkspaceIdBoardsWorkflowKeyRoute
  WorkspacesWorkspaceIdFilesAgentsSkillsRoute: typeof WorkspacesWorkspaceIdFilesAgentsSkillsRoute
  WorkspacesWorkspaceIdBoardsIndexRoute: typeof WorkspacesWorkspaceIdBoardsIndexRoute
  WorkspacesWorkspaceIdFilesIndexRoute: typeof WorkspacesWorkspaceIdFilesIndexRoute
  WorkspacesWorkspaceIdWorkflowsIndexRoute: typeof WorkspacesWorkspaceIdWorkflowsIndexRoute
  WorkspacesWorkspaceIdWorkflowsWorkflowKeyBoardRoute: typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyBoardRoute
  WorkspacesWorkspaceIdWorkflowsWorkflowKeyBuilderRoute: typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyBuilderRoute
  WorkspacesWorkspaceIdWorkflowsWorkflowKeyIndexRoute: typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyIndexRoute
  WorkspacesWorkspaceIdWorkflowsWorkflowKeyTasksTaskIdRunRoute: typeof WorkspacesWorkspaceIdWorkflowsWorkflowKeyTasksTaskIdRunRoute
}

const WorkspacesWorkspaceIdRouteRouteChildren: WorkspacesWorkspaceIdRouteRouteChildren =
  {
    WorkspacesWorkspaceIdAiUsageRouteRoute:
      WorkspacesWorkspaceIdAiUsageRouteRouteWithChildren,
    WorkspacesWorkspaceIdIntegrationsRouteRoute:
      WorkspacesWorkspaceIdIntegrationsRouteRouteWithChildren,
    WorkspacesWorkspaceIdSettingsRouteRoute:
      WorkspacesWorkspaceIdSettingsRouteRouteWithChildren,
    WorkspacesWorkspaceIdAiModelsRoute: WorkspacesWorkspaceIdAiModelsRoute,
    WorkspacesWorkspaceIdAuditRoute: WorkspacesWorkspaceIdAuditRoute,
    WorkspacesWorkspaceIdConnectionsRoute:
      WorkspacesWorkspaceIdConnectionsRoute,
    WorkspacesWorkspaceIdExecutionImagesRoute:
      WorkspacesWorkspaceIdExecutionImagesRoute,
    WorkspacesWorkspaceIdLibraryRoute: WorkspacesWorkspaceIdLibraryRoute,
    WorkspacesWorkspaceIdSecretsRoute: WorkspacesWorkspaceIdSecretsRoute,
    WorkspacesWorkspaceIdTasksRoute: WorkspacesWorkspaceIdTasksRoute,
    WorkspacesWorkspaceIdTriggersRoute: WorkspacesWorkspaceIdTriggersRoute,
    WorkspacesWorkspaceIdUsageRoute: WorkspacesWorkspaceIdUsageRoute,
    WorkspacesWorkspaceIdIndexRoute: WorkspacesWorkspaceIdIndexRoute,
    WorkspacesWorkspaceIdBoardsWorkflowKeyRoute:
      WorkspacesWorkspaceIdBoardsWorkflowKeyRoute,
    WorkspacesWorkspaceIdFilesAgentsSkillsRoute:
      WorkspacesWorkspaceIdFilesAgentsSkillsRoute,
    WorkspacesWorkspaceIdBoardsIndexRoute:
      WorkspacesWorkspaceIdBoardsIndexRoute,
    WorkspacesWorkspaceIdFilesIndexRoute: WorkspacesWorkspaceIdFilesIndexRoute,
    WorkspacesWorkspaceIdWorkflowsIndexRoute:
      WorkspacesWorkspaceIdWorkflowsIndexRoute,
    WorkspacesWorkspaceIdWorkflowsWorkflowKeyBoardRoute:
      WorkspacesWorkspaceIdWorkflowsWorkflowKeyBoardRoute,
    WorkspacesWorkspaceIdWorkflowsWorkflowKeyBuilderRoute:
      WorkspacesWorkspaceIdWorkflowsWorkflowKeyBuilderRoute,
    WorkspacesWorkspaceIdWorkflowsWorkflowKeyIndexRoute:
      WorkspacesWorkspaceIdWorkflowsWorkflowKeyIndexRoute,
    WorkspacesWorkspaceIdWorkflowsWorkflowKeyTasksTaskIdRunRoute:
      WorkspacesWorkspaceIdWorkflowsWorkflowKeyTasksTaskIdRunRoute,
  }

const WorkspacesWorkspaceIdRouteRouteWithChildren =
  WorkspacesWorkspaceIdRouteRoute._addFileChildren(
    WorkspacesWorkspaceIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  NotificationsRoute: NotificationsRoute,
  WorkspacesWorkspaceIdRouteRoute: WorkspacesWorkspaceIdRouteRouteWithChildren,
  OidcCallbackRoute: OidcCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
